import { IPOS, IPO_ERROR, IPO_HIDE_ERROR, IPO_START_LOADER, IPO_STOP_LOADER, } from "../interface/iIPO";
const initState = {
    data: {
        ipoOngoing: [],
        ipoUpcoming: [],
        ipoAboutList: [],
        ipoListed: [],
        ipoToday: [],
    },
    ipoLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const ipoReducer = (state = initState, action) => {
    switch (action.type) {
        case IPOS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case IPO_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case IPO_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case IPO_START_LOADER:
            return Object.assign(Object.assign({}, state), { ipoLoader: true });
        case IPO_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { ipoLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default ipoReducer;
